module.exports = __webpack_public_path__ + "static/media/1004870.e499ac33.png";